module.exports = __webpack_public_path__ + "img/wwjd-zyzzc@2x.d73e47e3.png";